interface Props {
  key: string;
  items: {
    title_en: string;
    content_en: string;
    high_season_en: string;
    low_season_en: string;
    std_season_en: string;
    background_alt_en: string;
    title_es: string;
    content_es: string;
    high_season_es: string;
    low_season_es: string;
    std_season_es: string;
    background_alt_es: string;
    typeColor: string;
    backgroundIcon: {
      publicURL: string;
    };
  }[];
}

export const ticketCardPropsMapping = (props: Props, locale: 'en' | 'es') => {
  return {
    widgetType: 'ticketcard',
    key: props.key,
    items: props.items.map((item) => ({
      title: item[`title_${locale}`],
      content: item[`content_${locale}`],
      highSeason: item[`high_season_${locale}`],
      lowSeason: item[`low_season_${locale}`],
      stdSeason: item[`std_season_${locale}`],
      backgroundIcon: item.backgroundIcon.publicURL,
      typeColor: item.typeColor,
      alt: item[`background_alt_${locale}`],
    })),
  };
};
